import { LINKS } from "./constants";

/*
 * Device-aware store URL selection.
 *
 * Returns the Play Store URL for Android user agents, App Store URL for
 * everything else. Defaults to App Store when navigator isn't available
 * (SSR / prerender / non-browser environments) so the prerendered HTML
 * carries a safe, meaningful href that works even if JavaScript never
 * runs on the client.
 */
export function detectStoreUrl() {
    if (typeof navigator === "undefined") return LINKS.appStore;
    return /android/i.test(navigator.userAgent)
        ? LINKS.playStore
        : LINKS.appStore;
}

/*
 * Click handler that intercepts an anchor navigation and redirects the
 * user to the correct store based on their device. Use with an anchor
 * whose `href` is set to LINKS.appStore — that way JS-disabled clients
 * still land on a real store page, while Android users get the correct
 * Play Store redirect via this handler.
 */
export function handleStoreClick(e) {
    if (typeof navigator === "undefined") return;
    if (/android/i.test(navigator.userAgent)) {
        e.preventDefault();
        window.open(LINKS.playStore, "_blank", "noopener,noreferrer");
    }
}
